// Centralized site configuration toggle for releasing the movie
export const SHOW_COMING_SOON = false;

// Centralized site configuration toggle for World Premiere RSVP popup
export const SHOW_PREMIERE_RSVP = false;
